import $ from 'jquery';

function changeShippingValues(address1, address2, city, state, zip) {

    let overwriteAddressInput = document.getElementById('ffl-checkout-by-ttg-for-woocommerce-input-overwrite_ffl_ttg_address_1');
    changeValue(overwriteAddressInput, address1);

    let overwriteAddress2Input = document.getElementById('ffl-checkout-by-ttg-for-woocommerce-input-overwrite_ffl_ttg_address_2');
    changeValue(overwriteAddress2Input, address2);

    let overwriteCityInput = document.getElementById('ffl-checkout-by-ttg-for-woocommerce-input-overwrite_ffl_ttg_city');
    changeValue(overwriteCityInput, city);

    let overwriteStateInput = document.getElementById('ffl-checkout-by-ttg-for-woocommerce-input-overwrite_ffl_ttg_state');
    changeValue(overwriteStateInput, state);

    let overwriteZipInput = document.getElementById('ffl-checkout-by-ttg-for-woocommerce-input-overwrite_ffl_ttg_postcode');
    changeValue(overwriteZipInput, zip);


    // Classic version
    $("#shipping_address_1").val(address1);
    $("#shipping_city").val(city);
    $("#shipping_address_2_field").val(address2);
    $("#shipping_state").val(state);
    $("#shipping_postcode").val(zip);
}

function getSelectedFFL() {

    if ($("#shipping_ffl_ttg_option")) {

        let selectionType = $("#shipping_ffl_ttg_option").val();

        if (selectionType == "upload_ffl") {
            return $("#shipping_ffl_ttg_license_number").val();
        }

        if (selectionType == "pick_ffl") {
            return $("#shipping_ffl_ttg_chosen_ffl").val();
        }

    }

    let selectionType = $("#ffl-checkout-by-ttg-for-woocommerce-input-shipping_ffl_ttg_option").val();

    if (selectionType == "upload_ffl") {
        return $("#ffl-checkout-by-ttg-for-woocommerce-input-shipping_ffl_ttg_license_number").val();
    }

    if (selectionType == "pick_ffl") {
        return $("#ffl-checkout-by-ttg-for-woocommerce-input-shipping_ffl_ttg_chosen_ffl").val();
    }

    return "";
}

function showSOTUploadOptions(showAlreadyUploadedOption = false) {

    if (!isSOTUploadEnabled()) {
        return;
    }

    if (showAlreadyUploadedOption == false) {
        $("#ffl-checkout-by-ttg-already-uploaded-option").hide();
    }

    if (showAlreadyUploadedOption == true) {
        $("#ffl-checkout-by-ttg-already-uploaded-option").show();
    }

    $("[name='ffl-checkout-by-ttg-option-selected-sot']").prop('checked', false);
    $("#ffl-checkout-by-ttg-sot-wrapper").slideDown();
}

function hideSOTUploadOptions() {

    if (!isSOTUploadEnabled()) {
        return;
    }

    $("[name='ffl-checkout-by-ttg-option-selected-sot']").prop('checked', false);
    
    $("#ffl-checkout-by-ttg-sot-wrapper").hide();
}

function isSOTUploadEnabled() {

    return $("#ffl-checkout-by-ttg-sot-wrapper").data("is-sot-required") == true;
}

function changeValue(input, value){

    try {

        var nativeInputValueSetter = Object.getOwnPropertyDescriptor( window.HTMLInputElement.prototype, "value" ).set;
            nativeInputValueSetter.call(input, value);

        var inputEvent = new Event("input", { bubbles: true });
        input.dispatchEvent(inputEvent);
        
    } catch (error) {  }
}

export { changeValue, getSelectedFFL, changeShippingValues, showSOTUploadOptions, hideSOTUploadOptions, isSOTUploadEnabled }